import { useState, useEffect } from "react";
import ProfileMenu from "./ProfileMenu";
import { supabase } from "../utils/supabase";
import AboutModal from "./AboutModal";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    //Check if user is already logged in
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user || null);
    });

    // Listen for auth changes (login/logout)
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <>
      <nav
        className="fixed top-0 left-0 right-0 z-[200] h-[80px] flex items-center justify-between px-6 md:px-10 transition-all duration-500"
        style={{
          backgroundColor: "rgba(7, 7, 7, 0.95)",
          backdropFilter: "blur(10px)",
        }}
      >
        <div
          onClick={() => {
            navigate("/");
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-3 no-underline outline-none cursor-pointer"
        >
          {/* Spinning Pixrd Wheel Logo */}
          <svg
            className="w-8 h-8"
            style={{
              animation: "spin 18s linear infinite",
              filter: "drop-shadow(0 0 6px rgba(255, 107, 0, 0.47))",
            }}
            viewBox="0 0 120 120"
          >
            <circle
              cx="60"
              cy="60"
              r="54"
              stroke="#FF6B00"
              strokeWidth="6"
              fill="none"
            />
            <circle
              cx="60"
              cy="60"
              r="38"
              stroke="#FF6B00"
              strokeWidth="1"
              fill="none"
              opacity="0.18"
            />
            <line
              x1="60"
              y1="6"
              x2="60"
              y2="52"
              stroke="#FF6B00"
              strokeWidth="5"
              strokeLinecap="square"
            />
            <line
              x1="60"
              y1="68"
              x2="60"
              y2="114"
              stroke="#FF6B00"
              strokeWidth="5"
              strokeLinecap="square"
            />
            <line
              x1="6"
              y1="60"
              x2="52"
              y2="60"
              stroke="#FF6B00"
              strokeWidth="5"
              strokeLinecap="square"
            />
            <line
              x1="68"
              y1="60"
              x2="114"
              y2="60"
              stroke="#FF6B00"
              strokeWidth="5"
              strokeLinecap="square"
            />
            <line
              x1="22"
              y1="22"
              x2="52"
              y2="52"
              stroke="#FF9A3C"
              strokeWidth="3"
              strokeLinecap="square"
            />
            <line
              x1="68"
              y1="68"
              x2="98"
              y2="98"
              stroke="#FF9A3C"
              strokeWidth="3"
              strokeLinecap="square"
            />
            <line
              x1="98"
              y1="22"
              x2="68"
              y2="52"
              stroke="#FF9A3C"
              strokeWidth="3"
              strokeLinecap="square"
            />
            <line
              x1="52"
              y1="68"
              x2="22"
              y2="98"
              stroke="#FF9A3C"
              strokeWidth="3"
              strokeLinecap="square"
            />
            <rect x="53" y="0" width="14" height="11" fill="#FF6B00" />
            <rect x="53" y="109" width="14" height="11" fill="#FF6B00" />
            <rect x="0" y="53" width="11" height="14" fill="#FF6B00" />
            <rect x="109" y="53" width="11" height="14" fill="#FF6B00" />
            <rect
              x="52"
              y="52"
              width="16"
              height="16"
              fill="#070707"
              stroke="#FF6B00"
              strokeWidth="2"
            />
            <rect x="54" y="54" width="5" height="5" fill="#FF6B00" />
            <rect x="61" y="54" width="5" height="5" fill="#FF9A3C" />
            <rect x="54" y="61" width="5" height="5" fill="#FF9A3C" />
            <rect x="61" y="61" width="5" height="5" fill="#FF6B00" />
          </svg>

          {/* PIXRD Text */}
          <span
            className="font-space text-xl tracking-tight text-text-primary"
            style={{ fontWeight: "800" }}
          >
            PIXRD
          </span>
        </div>

        {/* Right Side Links */}
        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => setIsAboutOpen(true)}
            className="font-space text-[10px] tracking-[3px] no-underline uppercase transition-colors duration-200"
            style={{ color: "#888888" }}
            onMouseEnter={(e) => (e.target.style.color = "#b0b0b0")}
            onMouseLeave={(e) => (e.target.style.color = "#888888")}
          >
            About
          </button>
          <button
            onClick={() => navigate("/pricing")}
            className="font-space text-[10px] tracking-[3px] no-underline uppercase transition-colors duration-200"
            style={{ color: "#888888" }}
            onMouseEnter={(e) => (e.target.style.color = "#b0b0b0")}
            onMouseLeave={(e) => (e.target.style.color = "#888888")}
          >
            Pricing
          </button>
          {/* Login and Signup Buttons */}
          {user ? (
            <ProfileMenu user={user} />
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="font-space text-[10px] tracking-[3px] no-underline uppercase transition-colors duration-200"
                style={{ color: "#888888" }}
                onMouseEnter={(e) => (e.target.style.color = "#b0b0b0")}
                onMouseLeave={(e) => (e.target.style.color = "#888888")}
              >
                Log In
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="font-space text-[10px] tracking-[3px] no-underline uppercase border px-5 py-2 transition-colors duration-200"
                style={{
                  color: "#FF6B00",
                  borderColor: "#FF6B00",
                  backgroundColor: "transparent",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#FF6B00";
                  e.target.style.color = "#000000";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#FF6B00";
                }}
              >
                Sign Up
              </button>
            </>
          )}
        </div>
        {/* Hamburger Button - Mobile Only */}
        <button
          className="md:hidden flex flex-col gap-1.5 w-8 h-8 items-center justify-center"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span
            className="w-6 h-0.5 bg-text-primary transition-all duration-300"
            style={{
              transform: isMenuOpen ? "rotate(45deg) translateY(8px)" : "none",
            }}
          />
          <span
            className="w-6 h-0.5 bg-text-primary transition-all duration-300"
            style={{ opacity: isMenuOpen ? 0 : 1 }}
          />
          <span
            className="w-6 h-0.5 bg-text-primary transition-all duration-300"
            style={{
              transform: isMenuOpen
                ? "rotate(-45deg) translateY(-8px)"
                : "none",
            }}
          />
        </button>
      </nav>
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="fixed top-[80px] left-0 right-0 bg-bg-primary border-b border-border z-[199] md:hidden">
          <div className="flex flex-col py-6 px-6 gap-6">
            {user ? (
              <>
                <div className="flex items-center gap-3 pb-2 broder-b border-[#222] mb-2">
                  <div
                    className="w-8 h-8 flex items-center justify-center text-[12px]"
                    style={{
                      backgroundColor: "#FF6B00",
                      color: "#000",
                      fontWeight: 700,
                    }}
                  >
                    {(user?.user_metadata?.full_name || user?.email || "U")
                      .charAt(0)
                      .toUpperCase()}
                  </div>
                  <div>
                    <p
                      className="text-text-primary text-[12px]"
                      style={{ fontWeight: 600 }}
                    >
                      {user?.user_metadata?.full_name || "user"}
                    </p>
                    <p className="text-[#888] text-[10px]">{user?.email}</p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    navigate("/account");
                    setIsMenuOpen(false);
                  }}
                  className="font-space text-[12px] tracking-[3px] uppercase w-full text-left"
                  style={{ color: "#888888", fontWeight: "700" }}
                >
                  Account
                </button>
                <button
                  onClick={async () => {
                    await supabase.auth.signOut();
                    setIsMenuOpen(false);
                    navigate("/");
                  }}
                  className="font-space text-[12px] tracking-[3px] uppercase w-full text-left"
                  style={{ color: "#888888", fontWeight: "700" }}
                >
                  Log Out
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => {
                    navigate("/signup");
                    setIsMenuOpen(false);
                  }}
                  className="font-space text-[12px] tracking-[3px] uppercase border px-6 py-3 text-center w-full"
                  style={{
                    color: "#FF6B00",
                    borderColor: "#FF6B00",
                    fontWeight: "700",
                  }}
                >
                  Sign Up
                </button>
                <button
                  onClick={() => {
                    navigate("/login");
                    setIsMenuOpen(false);
                  }}
                  className="font-space text-[12px] tracking-[3px] uppercase w-full text-left"
                  style={{ color: "#888888", fontWeight: "700" }}
                >
                  Log In
                </button>
              </>
            )}
            <button
              onClick={() => {
                navigate("/pricing");
                setIsMenuOpen(false);
              }}
              className="font-space text-[12px] tracking-[3px] uppercase w-full text-left"
              style={{ color: "#888888", fontWeight: "700" }}
            >
              Pricing
            </button>
            <button
              onClick={() => {
                setIsAboutOpen(true);
                setIsMenuOpen(false);
              }}
              className="font-space text-[12px] tracking-[3px] uppercase w-full text-left"
              style={{ color: "#888888", fontWeight: "700" }}
            >
              About
            </button>
          </div>
        </div>
      )}
      <AboutModal isOpen={isAboutOpen} onClose={() => setIsAboutOpen(false)} />
    </>
  );
}

export default Navbar;
